import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const RqmtList = ({ sectionId }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!sectionId) return;
    const expr = rowsReq.expr;
    rowsReq.expr = ExprUtils.and(expr, ExprUtils.whereParams('sectionId', sectionId))
  }, [sectionId]);

  return (
    <EntityList entity="RQMT" augRowsReq={augRowsReq}/>
  )
}